import { render, staticRenderFns } from "./hotelMsgReleaseList.vue?vue&type=template&id=159c3279&scoped=true"
import script from "./hotelMsgReleaseList.vue?vue&type=script&lang=js"
export * from "./hotelMsgReleaseList.vue?vue&type=script&lang=js"
import style0 from "./hotelMsgReleaseList.vue?vue&type=style&index=0&id=159c3279&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "159c3279",
  null
  
)

export default component.exports